export default __webpack_public_path__ + "static/2-e8339a6bf408b23794da83e0ca106560.png";